import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AiHubAuthModule } from "@aihub/core/authorization";
import { AiHubLoginPageModule } from "@aihub/ui/login-page";
import { AihubTooltipModule } from "@aihub/ui/tooltip";
import { MatSelectModule } from "@angular/material/select";
import { AiHubLoaderModule } from "@aihub/ui/loader";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatCardModule } from "@angular/material/card";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { MatButtonModule } from "@angular/material/button";
import { environment } from "@environments/environment";
import { CommonModule } from "@angular/common";
import { afterLoginHook } from "../../../shared-new/src/lib/utils/after-login-hook";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxFileDropModule } from "ngx-file-drop";
import { AiHubSelectModule } from "@aihub/ui/select";
import { MatTableModule } from "@angular/material/table";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTabsModule } from "@angular/material/tabs";
import { MarkdownModule } from "ngx-markdown";
import { MatMenuModule } from "@angular/material/menu";
import { SharedNewModule } from "projects/shared-new/src/public-api";
import { SharedModule } from "@shared";
import { DeloitteAiPageModule } from "@shared/page";
import { DeloitteAiHeaderModule } from "@shared/header";
import { DeloitteAiFooterModule } from "@shared/footer";
import { DeloitteAiBannerModule } from "@shared/banner";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "/assets/locales/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    StoreModule.forRoot({}),
    EffectsModule.forRoot({}),
    CommonModule,
    BrowserModule,
    MatSlideToggleModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    MatProgressBarModule,
    BrowserAnimationsModule,
    NgxFileDropModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatExpansionModule,
    MatCardModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatTableModule,
    MatGridListModule,
    MatChipsModule,
    MatTooltipModule,
    MatTabsModule,
    AihubTooltipModule,
    AiHubSelectModule,
    MarkdownModule.forRoot(),
    AiHubAuthModule.forRoot({
      firebase: environment.firebase,
      params: environment.authParams,
      signInType: environment.signInType,
      jwtInterceptHook: (uri: string) =>
        uri.startsWith(environment.subscriptionServiceBaseURL) ||
        uri.startsWith(environment.backendBaseURL) ||
        environment.local,
    }),
    AiHubLoginPageModule.forRoot(false, afterLoginHook),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatSelectModule,
    SharedModule,
    SharedNewModule,
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
